import React from 'react'
import { TriangleAlert } from 'lucide-react'
import EditLeadSubject from './edit'

class LeadSubjectsPartial extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      editing: false
    }
  }

  onClick = () => {
    if (this.state.editing === false) {
      this.setState({editing: true})
    }
  }

  onDoneEditing = () => {
    this.setState({editing: false})
  }

  render() {
    if (this.state.editing) {
      return (
        <EditLeadSubject
          lead={this.props.lead}
          subject={this.props.subject}
          onDone={this.onDoneEditing}
          store={this.props.store}
        />
      )
    }

    return (
      <div className="flex cursor-pointer items-start gap-2 px-4 py-3 hover:bg-muted/50" onClick={this.onClick}>
        {(!this.props.subject.known) ?
          <TriangleAlert className="mt-0.5 size-4 shrink-0 text-warning" aria-hidden="true" title='Unknown subject: check that the name, category and level match known information.'/>
          : null
        }
        <div className="min-w-0">
          <div className="text-sm font-medium">
            {this.props.subject.name}
            {this.props.subject.syllabus ?
              <span>&nbsp;({this.props.subject.syllabus})</span>
              : null
            }
          </div>
          <div className="text-sm text-muted-foreground">{this.props.subject.subject_level_name} {this.props.subject.subject_category_name}</div>
        </div>
      </div>
    )
  }
}

export default LeadSubjectsPartial
